export default __webpack_public_path__ + "static/media/facebook-icon.fd33cb85.svg";